import { GiftCardFieldNames } from "checkout-query-client/types/chex-form-fields";
import { FormConfig, InputType } from "checkout-query-client/types/form-types";

export const giftCardFormConfig: FormConfig<GiftCardFieldNames> = {
  active: true,
  title: "Gift Card",
  inputs: [
    {
      id: "giftCardNumber",
      type: InputType.text,
      initialValue: "",
      active: true,
      grid: {
        small: {
          minWidth: "100%",
          flex: "1",
        },
        medium: {
          minWidth: "100%",
          flex: "1",
        },
        large: {
          minWidth: "100%",
          flex: "100",
        },
      },
    },
    {
      id: "pinCode",
      type: InputType.securityCode,
      initialValue: "",
      active: true,
      grid: {
        small: {
          minWidth: "100%",
          flex: "1",
        },
        medium: {
          minWidth: "50%",
          flex: "0.5",
        },
        large: {
          minWidth: "50%",
          flex: "0.5",
        },
      },
    },
  ],
};
